import React, { useEffect, useState } from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';
import Input from '../../../components/ui/Input';
import Select from '../../../components/ui/Select';
import api from 'utils/api';

const ServiceManagement = (selectedSalon) => {
  const [searchTerm, setSearchTerm] = useState('');
  const [showAddModal, setShowAddModal] = useState(false);
  const [showEditModal, setShowEditModal] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [selectedService, setSelectedService] = useState(null);
  const [services, setServices] = useState([]);
  const [featureInput, setFeatureInput] = useState('');

  const [formData, setFormData] = useState({
    name: '',
    category: '',
    duration: '',
    price: '',
    description: '',
    serviceFeatures: [],
  });
  console.log('formData', formData);
  // const services = [
  //   {
  //     id: 1,
  //     name: 'کوتاهی مو',
  //     category: 'مو',
  //     duration: 45,
  //     price: 250000,
  //     description: 'کوتاهی و اصلاح مو با آخرین مدل‌های روز',
  //     status: 'فعال',
  //     bookings: 24
  //   },
  //   {
  //     id: 2,
  //     name: 'رنگ مو',
  //     category: 'مو',
  //     duration: 120,
  //     price: 450000,
  //     description: 'رنگ مو با رنگ‌های طبیعی و مقاوم',
  //     status: 'فعال',
  //     bookings: 18
  //   },
  //   {
  //     id: 3,
  //     name: 'فر مو',
  //     category: 'مو',
  //     duration: 90,
  //     price: 350000,
  //     description: 'فر دائم و موقت با تکنیک‌های مدرن',
  //     status: 'فعال',
  //     bookings: 12
  //   },
  //   {
  //     id: 4,
  //     name: 'مانیکور',
  //     category: 'ناخن',
  //     duration: 60,
  //     price: 180000,
  //     description: 'مراقبت کامل از ناخن‌های دست',
  //     status: 'فعال',
  //     bookings: 32
  //   },
  //   {
  //     id: 5,
  //     name: 'پدیکور',
  //     category: 'ناخن',
  //     duration: 75,
  //     price: 220000,
  //     description: 'مراقبت کامل از ناخن‌های پا',
  //     status: 'فعال',
  //     bookings: 28
  //   },
  //   {
  //     id: 6,
  //     name: 'پاکسازی پوست',
  //     category: 'پوست',
  //     duration: 90,
  //     price: 320000,
  //     description: 'پاکسازی عمیق پوست صورت',
  //     status: 'غیرفعال',
  //     bookings: 8
  //   }
  // ];

  const getServices = async () => {
    try {
      const response = await api.get(
        `/salons/651a6b2f8b7a5a1d223e4c90/services`
      );
      console.log(response.data);
      setServices(response.data);
      return response.data; // array of services
    } catch (error) {
      console.error('Error fetching services:', error);
      return []; // return empty array on error
    }
  };

  useEffect(() => {
    getServices();
  }, [selectedSalon]);

  const categoryOptions = [
    { value: 'vip', label: 'Basic' },
    { value: 'basic', label: 'VIP' },
  ];

  const filteredServices = services?.filter(
    (service) =>
      service?.name?.toLowerCase()?.includes(searchTerm?.toLowerCase()) ||
      service?.category?.toLowerCase()?.includes(searchTerm?.toLowerCase()) ||
      service?.description?.toLowerCase()?.includes(searchTerm?.toLowerCase())
  );

  const handleAddService = () => {
    console.log('handle add service');
    setFormData({
      name: '',
      category: '',
      duration: '',
      price: '',
      description: '',
      serviceFeatures: [],
    });
    setFeatureInput('');
    setShowAddModal(true);
  };

  const handleEditService = (service) => {
    setSelectedService(service);

    setFormData({
      name: service?.name,
      category:
        categoryOptions?.find((opt) => opt.value === service?.category)
          ?.value || '',
      duration: service?.duration?.toString(),
      price: service?.price?.toString(),
      description: service?.description,
      serviceFeatures: service?.serviceFeatures || [], // <-- REQUIRED
    });

    setFeatureInput('');
    setShowEditModal(true);
  };

  const handleDeleteService = (service) => {
    setSelectedService(service);
    setShowDeleteModal(true);
  };

  const handleFormSubmit = (e) => {
    e?.preventDefault();
    console.log('Form submitted:', formData);
    setShowAddModal(false);
    setShowEditModal(false);
  };

  const formatPrice = (price) => {
    return new Intl.NumberFormat('fa-IR')?.format(price) + ' تومان';
  };

  const formatDuration = (duration) => {
    return `${duration} دقیقه`;
  };

  const getStatusColor = (status) => {
    switch (status) {
      case 'فعال':
        return 'text-success bg-success/10';
      case 'غیرفعال':
        return 'text-error bg-error/10';
      default:
        return 'text-muted-foreground bg-muted';
    }
  };

  const getCategoryColor = (category) => {
    switch (category) {
      case 'مو':
        return 'text-blue-600 bg-blue-50';
      case 'ناخن':
        return 'text-pink-600 bg-pink-50';
      case 'پوست':
        return 'text-green-600 bg-green-50';
      default:
        return 'text-gray-600 bg-gray-50';
    }
  };

  return (
    <div className="space-y-6">
      {/* Header and Search */}
      <div className="flex flex-col sm:flex-row gap-4 justify-between items-start sm:items-center">
        <div>
          <h2 className="text-xl font-semibold text-foreground">
            مدیریت خدمات
          </h2>
          <p className="text-sm text-muted-foreground mt-1">
            تنظیم خدمات، قیمت‌گذاری و مدت زمان ارائه
          </p>
        </div>
        <Button
          variant="default"
          onClick={handleAddService}
          iconName="Plus"
          iconPosition="right">
          افزودن خدمت جدید
        </Button>
      </div>
      {/* Search and Filters */}
      <div className="flex flex-col sm:flex-row gap-4">
        {/* <div className="flex-1">
          <Input
            type="search"
            placeholder="جستجو بر اساس نام، دسته‌بندی یا توضیحات..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e?.target?.value)}
            className="w-full"
          />
        </div> */}
      </div>
      {/* Services Table - Desktop */}
      <div className="hidden lg:block bg-card border border-border rounded-lg overflow-hidden">
        <div className="overflow-x-auto">
          <table className="w-full">
            <thead className="bg-muted/50 border-b border-border">
              <tr>
                <th className="text-right px-6 py-4 text-sm font-medium text-foreground">
                  نام خدمت
                </th>
                <th className="text-right px-6 py-4 text-sm font-medium text-foreground">
                  دسته‌بندی
                </th>
                <th className="text-right px-6 py-4 text-sm font-medium text-foreground">
                  مدت زمان
                </th>
                <th className="text-right px-6 py-4 text-sm font-medium text-foreground">
                  قیمت
                </th>
                <th className="text-right px-6 py-4 text-sm font-medium text-foreground">
                  رزروها
                </th>
                <th className="text-right px-6 py-4 text-sm font-medium text-foreground">
                  وضعیت
                </th>
                <th className="text-center px-6 py-4 text-sm font-medium text-foreground">
                  عملیات
                </th>
              </tr>
            </thead>
            <tbody className="divide-y divide-border">
              {filteredServices?.map((service) => (
                <tr
                  key={service?.id}
                  className="hover:bg-muted/30 transition-colors duration-150">
                  <td className="px-6 py-4">
                    <div>
                      <p className="text-sm font-medium text-foreground">
                        {service?.name}
                      </p>
                      <p className="text-xs text-muted-foreground mt-1 max-w-xs truncate">
                        {service?.description}
                      </p>
                    </div>
                  </td>
                  <td className="px-6 py-4">
                    <span
                      className={`inline-block px-2 py-1 text-xs rounded-md ${getCategoryColor(
                        service?.serviceType
                      )}`}>
                      {service?.serviceType}
                    </span>
                  </td>
                  <td className="px-6 py-4">
                    <p className="text-sm text-foreground">
                      {formatDuration(service?.duration)}
                    </p>
                  </td>
                  <td className="px-6 py-4">
                    <p className="text-sm font-medium text-foreground">
                      {formatPrice(service?.price)}
                    </p>
                  </td>
                  <td className="px-6 py-4">
                    <div className="flex items-center gap-2">
                      <Icon
                        name="Calendar"
                        size={14}
                        className="text-muted-foreground"
                      />
                      <span className="text-sm text-foreground">
                        {service?.bookings}
                      </span>
                    </div>
                  </td>
                  <td className="px-6 py-4">
                    <span
                      className={`inline-block px-2 py-1 text-xs rounded-md ${getStatusColor(
                        service?.status
                      )}`}>
                      {service?.status}
                    </span>
                  </td>
                  <td className="px-6 py-4">
                    <div className="flex items-center justify-center gap-2">
                      <Button
                        variant="ghost"
                        size="icon"
                        onClick={() => handleEditService(service)}
                        iconName="Edit"
                        iconSize={16}
                      />
                      <Button
                        variant="ghost"
                        size="icon"
                        onClick={() => handleDeleteService(service)}
                        iconName="Trash2"
                        iconSize={16}
                        className="text-error hover:text-error"
                      />
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
      {/* Service Cards - Mobile */}
      <div className="lg:hidden space-y-4">
        {filteredServices?.map((service) => (
          <div
            key={service?.id}
            className="bg-card border border-border rounded-lg p-4">
            <div className="flex items-start justify-between mb-3">
              <div className="flex-1">
                <div className="flex items-center gap-2 mb-2">
                  <h3 className="text-sm font-medium text-foreground">
                    {service?.name}
                  </h3>
                  <span
                    className={`inline-block px-2 py-1 text-xs rounded-md ${getCategoryColor(
                      service?.category
                    )}`}>
                    {service?.category}
                  </span>
                </div>
                <p className="text-xs text-muted-foreground mb-2">
                  {service?.description}
                </p>
              </div>
              <span
                className={`inline-block px-2 py-1 text-xs rounded-md ${getStatusColor(
                  service?.status
                )}`}>
                {service?.status}
              </span>
            </div>

            <div className="grid grid-cols-3 gap-4 mb-4">
              <div>
                <p className="text-xs text-muted-foreground">مدت زمان</p>
                <p className="text-sm font-medium text-foreground">
                  {formatDuration(service?.duration)}
                </p>
              </div>
              <div>
                <p className="text-xs text-muted-foreground">قیمت</p>
                <p className="text-sm font-medium text-foreground">
                  {formatPrice(service?.price)}
                </p>
              </div>
              <div>
                <p className="text-xs text-muted-foreground">رزروها</p>
                <p className="text-sm font-medium text-foreground">
                  {service?.bookings}
                </p>
              </div>
            </div>

            <div className="flex gap-2">
              <Button
                variant="outline"
                size="sm"
                onClick={() => handleEditService(service)}
                iconName="Edit"
                iconPosition="right"
                className="flex-1">
                ویرایش
              </Button>
              <Button
                variant="outline"
                size="sm"
                onClick={() => handleDeleteService(service)}
                iconName="Trash2"
                iconPosition="right"
                className="text-error border-error hover:bg-error/10">
                حذف
              </Button>
            </div>
          </div>
        ))}
      </div>
      {/* Add/Edit Service Modal */}
      {(showAddModal || showEditModal) && (
        <div className="fixed inset-0 bg-black/50 backdrop-blur-modal z-modal flex items-center justify-center p-4">
          <div className="bg-popover border border-border rounded-lg w-full max-w-2xl max-h-[90vh] overflow-y-auto animate-scale-in">
            <div className="p-6">
              <div className="flex items-center justify-between mb-6">
                <h3 className="text-lg font-semibold text-foreground">
                  {showAddModal ? 'افزودن خدمت جدید' : 'ویرایش اطلاعات خدمت'}
                </h3>
                <Button
                  variant="ghost"
                  size="icon"
                  onClick={() => {
                    setShowAddModal(false);
                    setShowEditModal(false);
                  }}
                  iconName="X"
                  iconSize={20}
                />
              </div>

              <form onSubmit={handleFormSubmit} className="space-y-4">
                <Input
                  label="نام خدمت"
                  type="text"
                  placeholder="نام خدمت را وارد کنید"
                  value={formData?.name}
                  onChange={(e) =>
                    setFormData({ ...formData, name: e?.target?.value })
                  }
                  required
                />

                <Select
                  label="دسته‌بندی"
                  description="دسته‌بندی خدمت را انتخاب کنید"
                  options={categoryOptions}
                  value={formData?.category}
                  onChange={(value) =>
                    setFormData({ ...formData, category: value })
                  }
                  required
                />

                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                  <Input
                    label="مدت زمان (دقیقه)"
                    type="number"
                    placeholder="45"
                    value={formData?.duration}
                    onChange={(e) =>
                      setFormData({ ...formData, duration: e?.target?.value })
                    }
                    min="15"
                    max="300"
                    required
                  />
                  <Input
                    label="قیمت (تومان)"
                    type="number"
                    placeholder="250000"
                    value={formData?.price}
                    onChange={(e) =>
                      setFormData({ ...formData, price: e?.target?.value })
                    }
                    min="0"
                    required
                  />
                </div>
                {/* Service Features Section */}
                <div>
                  <label className="block text-sm font-medium text-foreground mb-2">
                    ویژگی‌های خدمت
                  </label>

                  <div className="flex gap-2 mb-2">
                    <Input
                      type="text"
                      placeholder="یک ویژگی وارد کنید..."
                      value={featureInput || ''}
                      onChange={(e) => setFeatureInput(e.target.value)}
                    />
                    <Button
                      type="button"
                      variant="secondary"
                      onClick={() => {
                        if (!featureInput) return;
                        setFormData({
                          ...formData,
                          serviceFeatures: [
                            ...formData.serviceFeatures,
                            featureInput,
                          ],
                        });
                        setFeatureInput('');
                      }}>
                      افزودن
                    </Button>
                  </div>

                  {/* Display current features */}
                  <div className="space-y-2">
                    {formData.serviceFeatures?.map((f, i) => (
                      <div
                        key={i}
                        className="flex items-center justify-between p-2 border rounded-md bg-muted">
                        <span>{f}</span>
                        <Button
                          type="button"
                          size="icon"
                          variant="ghost"
                          iconName="X"
                          onClick={() => {
                            const updated = formData.serviceFeatures.filter(
                              (_, idx) => idx !== i
                            );
                            setFormData({
                              ...formData,
                              serviceFeatures: updated,
                            });
                          }}
                        />
                      </div>
                    ))}
                  </div>
                </div>

                <div>
                  <label className="block text-sm font-medium text-foreground mb-2">
                    توضیحات خدمت
                  </label>
                  <textarea
                    placeholder="توضیحات کاملی از خدمت ارائه شده..."
                    value={formData?.description}
                    onChange={(e) =>
                      setFormData({
                        ...formData,
                        description: e?.target?.value,
                      })
                    }
                    rows={4}
                    className="w-full px-3 py-2 border border-border rounded-md bg-input text-foreground placeholder:text-muted-foreground focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent resize-none"
                  />
                </div>

                <div className="flex gap-3 pt-4">
                  <Button type="submit" variant="default" className="flex-1">
                    {showAddModal ? 'افزودن خدمت' : 'ذخیره تغییرات'}
                  </Button>
                  <Button
                    type="button"
                    variant="outline"
                    onClick={() => {
                      setShowAddModal(false);
                      setShowEditModal(false);
                    }}
                    className="flex-1">
                    انصراف
                  </Button>
                </div>
              </form>
            </div>
          </div>
        </div>
      )}
      {/* Delete Confirmation Modal */}
      {showDeleteModal && selectedService && (
        <div className="fixed inset-0 bg-black/50 backdrop-blur-modal z-modal flex items-center justify-center p-4">
          <div className="bg-popover border border-border rounded-lg w-full max-w-md animate-scale-in">
            <div className="p-6">
              <div className="flex items-center gap-3 mb-4">
                <div className="w-10 h-10 bg-error/10 rounded-full flex items-center justify-center">
                  <Icon name="AlertTriangle" size={20} className="text-error" />
                </div>
                <div>
                  <h3 className="text-lg font-semibold text-foreground">
                    حذف خدمت
                  </h3>
                  <p className="text-sm text-muted-foreground">
                    این عمل قابل بازگشت نیست
                  </p>
                </div>
              </div>

              <p className="text-sm text-foreground mb-6">
                آیا از حذف خدمت <strong>{selectedService?.name}</strong> اطمینان
                دارید؟ تمام اطلاعات مربوط به این خدمت حذف خواهد شد.
              </p>

              <div className="flex gap-3">
                <Button
                  variant="destructive"
                  onClick={() => {
                    console.log('Delete service:', selectedService?.id);
                    setShowDeleteModal(false);
                    setSelectedService(null);
                  }}
                  className="flex-1">
                  حذف خدمت
                </Button>
                <Button
                  variant="outline"
                  onClick={() => {
                    setShowDeleteModal(false);
                    setSelectedService(null);
                  }}
                  className="flex-1">
                  انصراف
                </Button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default ServiceManagement;
